import * as i0 from '@angular/core';
import { InjectionToken, inject, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

/**
 * The injection token to be used when used globally across the app
 */
const SI_COPYRIGHT_DETAILS = new InjectionToken('SI_COPYRIGHT_DETAILS');

class SiCopyrightNoticeComponent {
    globalCopyrightInfo = inject(SI_COPYRIGHT_DETAILS, {
        optional: true
    });
    /**
     * Copyright information to be displayed.
     *
     * Note: The {@link CopyrightDetails#company} defaults to `Siemens`,
     * only set it for other companies.
     */
    copyright;
    get company() {
        return this.copyright?.company ?? this.globalCopyrightInfo?.company ?? 'Siemens';
    }
    get startYear() {
        return (this.copyright?.startYear ?? this.globalCopyrightInfo?.startYear ?? new Date().getFullYear());
    }
    get lastUpdateYear() {
        return this.copyright?.lastUpdateYear ?? this.globalCopyrightInfo?.lastUpdateYear ?? undefined;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCopyrightNoticeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiCopyrightNoticeComponent, selector: "si-copyright-notice", inputs: { copyright: "copyright" }, ngImport: i0, template: "<p\n  >\u00A9 {{ company }} {{ startYear\n  }}<ng-container *ngIf=\"lastUpdateYear\">-{{ lastUpdateYear }}</ng-container>\n</p>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCopyrightNoticeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-copyright-notice', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p\n  >\u00A9 {{ company }} {{ startYear\n  }}<ng-container *ngIf=\"lastUpdateYear\">-{{ lastUpdateYear }}</ng-container>\n</p>\n" }]
        }], propDecorators: { copyright: [{
                type: Input
            }] } });

class SiCopyrightNoticeModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCopyrightNoticeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiCopyrightNoticeModule, declarations: [SiCopyrightNoticeComponent], imports: [CommonModule], exports: [SiCopyrightNoticeComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCopyrightNoticeModule, imports: [CommonModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiCopyrightNoticeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SiCopyrightNoticeComponent],
                    exports: [SiCopyrightNoticeComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SI_COPYRIGHT_DETAILS, SiCopyrightNoticeComponent, SiCopyrightNoticeModule };
